// eslint-disable-next-line no-restricted-imports
import { useCurrentOfficeId } from 'ap-openapi';
import { useMemo } from 'react';

// IP restriction also blocks GraphQL, so current office can't be fetched;
// use the officeId from props for the X-Office-Id verification (cross-tab office switch check).
export const useGetHeaderWithOfficeId = (officeId: string) => {
  const currentOfficeId = useCurrentOfficeId();
  return useMemo(() => {
    if (currentOfficeId || !officeId) return undefined;
    return { request: { headers: { 'X-Office-Id': officeId } } };
  }, [currentOfficeId, officeId]);
};
